export default __webpack_public_path__ + "static/media/event-banner-3.f787a3ea.svg";